export enum InvoicingMethod {
  Classical = 'classical',
  VendorPayment = 'vendor_payment'
}
